import React from 'react'
import { connect } from 'react-redux'
// import Loading from '../Shared/Loading'
import LoadingBar from '../Shared/LoadingBar'
import { Line } from 'rc-progress'
import { dashboardService } from '../../_services/dashboard.service'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import { MonthlyRegisterChart } from './MonthlyRegisterChart'
import 'react-circular-progressbar/dist/styles.css'
import 'react-table/react-table.css'
import 'antd/dist/antd.css'
import './dashboard.css'
import NumberFormat from 'react-number-format'

class Dashboard extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: true,
      key: 'tab1',
      data: {
        registeredCount: 0,
        registeredPercentage: 0,
        remainingCount: 0,
        thisMonthRegisteredCount: 0,
        totalPrice: 0,
        unionStatus: []
      }
    }
  }

  componentWillMount = () => {
    LoadingBar(true)

    this.getData()
  }

  getData() {
    dashboardService
      .getDashbardSummary()
      .then(res => {
        // console.log(res.data)
        var data = res.data
        this.setState({ data: data, loading: false }, () => {
          LoadingBar(false)
        })
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    LoadingBar(false)
    // console.log(error);
  }

  render() {
    const { data } = this.state
    return ((
      // !this.state.loading ?
      <div className="dashboard">
        <div className="row firstRow ">
          <div className="col-md-3">
            <div className="panelBox">
              <span>ظرفیت خالی کلاس ها</span>
              <h2>{data.remainingCount}</h2>
            </div>
          </div>
          <div className="col-md-3">
            <div className="panelBox">
              <span>ثبت نام شده</span>
              <h2>{data.registeredCount}</h2>
            </div>
          </div>
          <div className="col-md-3">
            <div className="panelBox">
              <span>جمع مبلغ ثبت نام شده</span>
              <h2 className="rtl">
                <NumberFormat
                  thousandSeparator={true}
                  className="numberFa"
                  value={data.totalPrice}
                  displayType="text"
                  suffix=" ریال"
                />
              </h2>
            </div>
          </div>
        </div>
        <div className="row sameHeight">
          <div className="col-md-3 col-xs-12">
            <div className="panelBox text-center" style={{ paddingBottom: 0 }}>
              <span className="title">وضعیت ظرفیت کلاس ها</span>
              <div className="circleProgressContainer">
                <CircularProgressbar
                  value={data.registeredPercentage}
                  text={`${data.registeredPercentage}%`}
                  strokeWidth={4}
                  circleRatio={0.75}
                  styles={buildStyles({
                    rotation: 1 / 2 + 1 / 8,
                    strokeLinecap: 'round',
                    pathColor: '#2DCD7A',
                    trailColor: '#D9D9D9'
                    // textColor: "#D9D9D9",
                  })}
                />
              </div>
              <div className="row" style={{ borderTop: 'thin solid #f1f1f1' }}>
                <div
                  className="col-sm-6"
                  style={{
                    borderLeft: 'thin solid #f1f1f1',
                    padding: 10,
                    marginBottom: 0
                  }}>
                  <span>ﻇﺮﻓﯿﺖ ﺧﺎﻟﯽ</span>
                  <h2 style={{ fontSize: '18px' }}>{data.remainingCount}</h2>
                </div>

                <div
                  className="col-sm-6"
                  style={{ paddingTop: 10, marginBottom: 0 }}>
                  <span>ﺛﺒﺖ ﻧﺎم ﺷﺪه</span>
                  <h2 style={{ fontSize: '18px' }}>{data.registeredCount}</h2>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-9 col-xs-12">
            <div className="panelBox">
              <span className="title pull-right">
                گزارش میزان ثبت نام های انجام شده در 1 ماه گذشته
              </span>
              <MonthlyRegisterChart data={data.monthlyRegister} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="panelBox text-center">
              <span className="title">
                میزان ثبت نام های انجام شده توسط اتحادیه ها
              </span>
              <br />
              <br />
              {data.unionStatus.map((item, index) => (
                <div className="row" key={index}>
                  <div className="col-md-12">
                    <span className="pull-left">{item.name}</span>
                    <span className="pull-right">
                      %
                      {item.percentage +
                        ' (تعداد ثبت نام ها: ' +
                        item.registeredCount +
                        ' )'}
                    </span>
                    <Line
                      percent={item.percentage}
                      strokeWidth="1"
                      strokeColor="#5079f7"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      // :
      // <Loading />
    ) /*:*/)
  }
}

function mapStateToProps(state) {
  const { users, authentication } = state
  const { user } = authentication
  return {
    user,
    users
  }
}

const connectedDashboard = connect(mapStateToProps)(Dashboard)
export { connectedDashboard as Dashboard }
